<template>
  <li class="venue">
    <div class="venue__details">
      <p class="venue__name">{{ venue.name }}</p>
      <div class="venue__address">
        <p
          class="venue__address-item"
          v-for="(addressLine, index) in formattedAddress"
          :key="index"
        >
          {{ addressLine }}
        </p>
      </div>
    </div>
    <div class="venue__logistics">
      <a class="venue__directions" :href="linkedAddress">Get Directions</a>
      <div :class="`venue__distance venue__distance--${distanceClass}`">
        {{ venue.location.distance }}m away
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: ["venue", "range"],
  computed: {
    formattedAddress() {
      const array = [...this.venue.location.formattedAddress];
      array.splice(-1, 1);
      return array;
    },
    linkedAddress() {
      const array = [...this.venue.location.formattedAddress];
      const urlAddress = array
        .join(", ")
        .split(" ")
        .join("+");
      return `https://www.google.com/maps/dir/?api=1&travelmode=walking&destination=${urlAddress}`;
    },
    distanceClass() {
      const [min, max] = this.range;
      const ranges = {
        nearest: min,
        near: max * 0.25,
        far: max * 0.5,
        furthest: max * 0.75
      };
      let className = ``;
      Object.values(ranges).forEach((range, index) => {
        if (this.venue.location.distance >= range) {
          className = Object.keys(ranges)[index];
        }
      });
      return className;
    }
  }
};
</script>

<style lang="scss">
$ranges: (
  nearest: var(--color--success),
  near: var(--color--alert),
  far: var(--color--warning),
  furthest: var(--color--error)
);
.venue {
  display: grid;
  grid-template-columns: 1fr auto;
  padding-top: 1.5rem;
  align-items: center;
  + .venue {
    border-top: 1px solid var(--color--mid);
  }
  &__logistics {
    text-align: right;
  }
  &__name {
    font-weight: 640;
    font-size: 1.5rem;
    margin: 0;
    line-height: 1.5;
  }
  &__address {
    font-size: 0.75rem;
    color: var(--color--mid);
  }
  &__address-item {
    line-height: 1.5;
    margin: 0;
  }
  &__directions {
    color: inherit;
    font-weight: 670;
    display: inline-block;
  }
  &__distance {
    font-size: 0.75rem;
    @each $range, $color in $ranges {
      @debug $range;
      &--#{$range} {
        color: $color;
      }
    }
  }
}
</style>
